// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2ArBs","info":"UpdateTermsInfo_info__36utp"};